// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Account_root__UjF8B {
  padding: 15px 40px 90px 40px;
  height: calc(100vh - 188px);
  overflow-y: scroll;
  color: var(--color-font-10);
  overflow: scroll;
  max-width: 1125px;
}

.Account_account_title__aaca3 {
  display: flex;
  align-items: center;
}

.Account_business_icon__tizd9 {
  padding-right: 10px;
}

.Account_arrow_icon__\\+\\+eob {
  padding: 0px 20px;
  color: var(--color-theme-silver);
}

.Account_account_title__aaca3 {
  display: flex;
  align-items: center;
}

.Account_business_icon__tizd9 {
  padding-right: 10px;
}

.Account_confirm_btn_container__XIDUC {
  text-align: right;
  width: 775px;
  margin: 20px 0 !important;
}

.Account_confirm_btn__zB3hH {
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  width: 174px;
  height: 41px;
  font-weight: bold !important;
}

.Account_account_content__eAzgB {
  width: 775px;
}

.Account_business_container__g607C {
  display: flex;
  justify-content: space-between;
}

.Account_business_col__ppF5T {
  padding: 20px 0;
}

.Account_info_text__Och7z {
  font-size: 16px;
}

.Account_info_text__Och7z a {
  color: var(--color-theme-blue);
  text-decoration: none;
}

.Account_input__ZaNfD:hover {
  text-decoration: none;
  border: none !important;
}

.Account_error_container__bVgSU {
  padding: 10px;
  margin: 0px 5px 25px 5px;
  background-color: var(--color-theme-red);
}

.Account_error_text__kUBLi {
  font-size: 16px;
  color: var(--color-theme-white);
}

.Account_empty_row__oCfUP {
  height: 80px;
}

.Account_input__ZaNfD {
  width: 370px !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/Account/Account.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".root {\n  padding: 15px 40px 90px 40px;\n  height: calc(100vh - 188px);\n  overflow-y: scroll;\n  color: var(--color-font-10);\n  overflow: scroll;\n  max-width: 1125px;\n}\n\n.account_title {\n  display: flex;\n  align-items: center;\n}\n\n.business_icon {\n  padding-right: 10px;\n}\n\n.arrow_icon {\n  padding: 0px 20px;\n  color: var(--color-theme-silver);\n}\n\n.account_title {\n  display: flex;\n  align-items: center;\n}\n\n.business_icon {\n  padding-right: 10px;\n}\n\n.confirm_btn_container {\n  text-align: right;\n  width: 775px;\n  margin: 20px 0 !important;\n}\n\n.confirm_btn {\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  width: 174px;\n  height: 41px;\n  font-weight: bold !important;\n}\n\n.account_content {\n  width: 775px;\n}\n\n.business_container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.business_col {\n  padding: 20px 0;\n}\n\n.info_text {\n  font-size: 16px;\n}\n\n.info_text a {\n  color: var(--color-theme-blue);\n  text-decoration: none;\n}\n\n.input:hover {\n  text-decoration: none;\n  border: none !important;\n}\n\n.error_container {\n  padding: 10px;\n  margin: 0px 5px 25px 5px;\n  background-color: var(--color-theme-red);\n}\n\n.error_text {\n  font-size: 16px;\n  color: var(--color-theme-white);\n}\n\n.empty_row {\n  height: 80px;\n}\n\n.input {\n  width: 370px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Account_root__UjF8B`,
	"account_title": `Account_account_title__aaca3`,
	"business_icon": `Account_business_icon__tizd9`,
	"arrow_icon": `Account_arrow_icon__++eob`,
	"confirm_btn_container": `Account_confirm_btn_container__XIDUC`,
	"confirm_btn": `Account_confirm_btn__zB3hH`,
	"account_content": `Account_account_content__eAzgB`,
	"business_container": `Account_business_container__g607C`,
	"business_col": `Account_business_col__ppF5T`,
	"info_text": `Account_info_text__Och7z`,
	"input": `Account_input__ZaNfD`,
	"error_container": `Account_error_container__bVgSU`,
	"error_text": `Account_error_text__kUBLi`,
	"empty_row": `Account_empty_row__oCfUP`
};
export default ___CSS_LOADER_EXPORT___;
